"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function Introduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="introduction" className="bg-background py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div ref={ref} className={cn("flex flex-col md:flex-row items-stretch gap-8 md:gap-0 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {}
          <div className="w-full md:w-8/12 md:pr-12 lg:pr-16 flex flex-col justify-center">
            <h1 className="text-[48px] font-bold font-default text-primary leading-[1.1] tracking-tight">
              The Housing Pressure Index.
            </h1>
            <p className="text-[20px] font-medium font-sans text-accent mt-6 max-w-2xl leading-relaxed">
              A comprehensive, real-time measure of housing market stress, tracking affordability, inventory constraints, and demand surges across key metropolitan areas to provide actionable insights.
            </p>
          </div>

          {}
          <div className="hidden md:flex w-px justify-center py-2">
            <Separator orientation="vertical" className="bg-primary h-full w-px" />
          </div>
          
          {}
          <Separator orientation="horizontal" className="md:hidden bg-primary w-full h-px my-4" />

          {}
          <div className="w-full md:w-4/12 md:pl-12 lg:pl-16 flex flex-col justify-center">
            <div className="font-mono text-primary text-sm md:text-base flex flex-col gap-4 tracking-tight bg-muted/30 p-6 rounded-md border border-border/50">
              <div className="flex justify-between items-center border-b border-border/50 pb-2">
                <span className="opacity-70">IDX_VAL</span>
                <span className="font-semibold text-lg">142.84</span>
              </div>
              <div className="flex justify-between items-center border-b border-border/50 pb-2">
                <span className="opacity-70">MOM_CHG</span>
                <span className="font-semibold text-chart-1">+1.24%</span>
              </div>
              <div className="flex justify-between items-center border-b border-border/50 pb-2">
                <span className="opacity-70">YOY_CHG</span>
                <span className="font-semibold text-chart-1">+8.41%</span>
              </div>
              <div className="flex justify-between items-center border-b border-border/50 pb-2">
                <span className="opacity-70">STATUS</span>
                <span className="font-semibold text-destructive">ELEVATED</span>
              </div>
              <div className="flex justify-between items-center pt-1">
                <span className="opacity-70">SYS_TIME</span>
                <span className="font-semibold">14:02:55 UTC</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}